import { Vue, Component } from 'vue-property-decorator';
import { Form } from 'element-ui';
import { State, Mutation } from 'vuex-class';
import { ILOGPRE } from '@/types/base.d';
import api from '@/api/course';

@Component
export default class formMixin extends Vue {
  @State(state => state.org.curComp) curComp!: string;

  @Mutation('org/SET_ORG_BTN_COMPENT') setCurComp!: Function;

  @Mutation('org/SET_ORG_COMPENT_REFRESH') handleRerfesh!: Function;

  public userInfos:any = []

  public works: any = []

  public log: ILOGPRE = {
    name: '机构管理 - 合同 - 模态框 -',
    component: 'org/manage/components/bModal',
  };

  public form: any = {
  };

  public loading: boolean = false;

  private userLoading: boolean = false;

  private userInfo: any = [];

  public $refs!: {
    form: Form,
  };

  private rules: any = {};

  handleUser(v: any) {
    this.userLoading = true;
    if (v) {
      api.getUser(v).then((res:any) => {
        this.userLoading = false;
        this.userInfo = res.map((el:any) => ({ value: el.pid, label: el.userTitle }));
      });
    }
  }

  /* eslint-disable class-methods-use-this */
  reset(close: boolean, refrsh: boolean) {}

  /**
   * @author liangyongmou
   * @desc 重置表单
   * @param 空
   */
  resetForm() {
    this.$refs.form.resetFields();
  }

  /**
   * @author Terry
   * @description 提交Form 完成后执行此方法
   */
  submitFinish() {
    this.reset(true, true);
    this.loading = false;
    if (this.curComp !== 'Contract') this.setCurComp('Contract');
    else this.handleRerfesh(true);
  }

  /**
   * @author liangyongmou
   * @desc 添加/编辑合同
   * @param { string } title 标题
   */
}
